import { Base64 } from "js-base64";

import { isBinaryBytes, getBinaryFileType } from "utils/binaryContent";
import { getRepoUrl } from "utils/spaceliftRepo";

export const SPACELIFT_VCS_REPO_SORT_STORAGE_KEY = "spaceliftVcsRepoSortConfig";

export const getRepoUsedByPageUrl = (repoId: string) => `${getRepoUrl(repoId)}/used-by`;

export const parseFilePath = (filePath: string) => {
  const lastSlash = filePath.lastIndexOf("/");
  if (lastSlash === -1) return { folder: "", segments: [], name: filePath };
  return {
    folder: filePath.slice(0, lastSlash),
    segments: filePath.slice(0, lastSlash).split("/"),
    name: filePath.slice(lastSlash + 1),
  };
};

export const buildPathSearch = (path: string) => (path ? `?${new URLSearchParams({ path })}` : "");

export const buildFolderBreadcrumbs = (repoUrl: string, segments: string[]) =>
  segments.map((segment, index) => ({
    title: segment,
    link: `${repoUrl}${buildPathSearch(segments.slice(0, index + 1).join("/"))}`,
  }));

/**
 * Build the edit URL for a file: /spacelift-repos/:repoId/edit/:fileName?path=folderPath
 * The folder portion goes into a query param so special characters are safely encoded.
 */
export const getFileEditUrl = (repoId: string, filePath: string) => {
  const { name, folder } = parseFilePath(filePath);
  const base = `${getRepoUrl(repoId)}/edit/${encodeURIComponent(name)}`;
  return `${base}${buildPathSearch(folder)}`;
};

export const decodeFileContent = (raw: string | undefined | null) => {
  if (!raw) return { content: undefined, isBinary: false, fileType: undefined };
  const bytes = Base64.toUint8Array(raw);
  const isBinary = isBinaryBytes(bytes);

  return {
    content: isBinary ? undefined : Base64.decode(raw),
    isBinary,
    fileType: isBinary ? getBinaryFileType(bytes) : undefined,
  };
};
